import type { AdminRelationships, AdminScope } from './api';

export interface EntityReference {
  scope: AdminScope;
  id: string;
}
export function directOwners(data: AdminRelationships, companyId: string) {
  const ids = new Set(
    data.memberships
      .filter(
        (m) => m.companyId === companyId && !m.adviserPracticeId && m.active && m.role === 'owner'
      )
      .map((m) => m.userId)
  );
  return data.users.filter((user) => ids.has(user.id));
}
export function activeCompanyMembers(data: AdminRelationships, companyId: string) {
  return data.memberships.filter((m) => m.companyId === companyId && m.active);
}
export function practiceCompanies(data: AdminRelationships, practiceId: string) {
  const linked = new Set(
    data.clientLinks
      .filter((link) => link.practiceId === practiceId && link.status !== 'revoked')
      .map((link) => link.companyId)
  );
  return data.companies.filter(
    (company) => linked.has(company.id) || company.demoPracticeId === practiceId
  );
}
export function personCompanies(data: AdminRelationships, userId: string) {
  const ids = new Set(
    data.memberships.filter((m) => m.userId === userId && m.active).map((m) => m.companyId)
  );
  return data.companies.filter((company) => ids.has(company.id));
}
export function personPractices(data: AdminRelationships, userId: string) {
  const ids = new Set(
    data.practiceMembers.filter((m) => m.userId === userId).map((m) => m.practiceId)
  );
  return data.practices.filter((practice) => ids.has(practice.id));
}
export function entityName(data: AdminRelationships, ref: EntityReference) {
  return (
    (ref.scope === 'user'
      ? data.users
      : ref.scope === 'company'
        ? data.companies
        : data.practices
    ).find((item) => item.id === ref.id)?.name || 'Unavailable record'
  );
}
export function companyPractice(data: AdminRelationships, companyId: string) {
  const company = data.companies.find((c) => c.id === companyId);
  const link = data.clientLinks.find((l) => l.companyId === companyId && l.status !== 'revoked');
  return data.practices.find((p) => p.id === (company?.demoPracticeId || link?.practiceId));
}
